/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import BaseComponent from "../../../base/BaseComponent";
import {Table, Input, Checkbox, Button, Select, DatePicker, Radio, Popover, Pagination} from "antd";
const { Search } = Input;
const { Option } = Select;
const {RangePicker} = DatePicker;



export default class ChoiceType extends BaseComponent {
    static defaultProps = {
        searhShow: true,
        RangePickerShow: true,
        SelectShow: true
    };
    static propTypes = {
        searhShow: PropTypes.bool,// 输入框是否显示
        RangePickerShow: PropTypes.bool,// 时间选择器是否显示
        SelectShow: PropTypes.bool,// 选择器是否
    };

    constructor(props) {
        super(props);
        this.state = {
            typeList: [],//全部类型
            selectName: '全部类型',
            selectType:[],
            searchText: '',//搜索的文字
            startTime: '',//开始时间
            endTime: '',//结束时间
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.getAllType()

    }
    render() {
        return (
            <div>{this.renderBtn()}</div>
        )
    }
    renderBtn() {
        return (
            <div style={{display: 'flex', alignItems: "center"}}>
                {this.props.searhShow ? <Search
                    placeholder="请输入关键字"
                    allowClear={true}
                    onSearch={value => {
                        this.setState({searchText: value}, () => {
                            this.props.onSaveCallback && this.props.onSaveCallback(this.state.searchText, this.state.selectType, this.state.startTime, this.state.endTime)
                        })
                    }}
                    style={{width: 224}}

                /> : null}
                {
                    this.props.RangePickerShow ? <div style={{marginLeft: '24px'}}>
                        <RangePicker allowClear onChange={this.rangePickerChange}/>
                    </div> : null
                }
                {
                    this.props.SelectShow ?
                        <Select value={this.state.selectName} style={{width: 224, marginLeft: '24px'}}
                                onChange={(value) => this.handleChange(value)}>
                            {
                                this.state.typeList && this.state.typeList.length && this.state.typeList.map((item, index) => {
                                    return (
                                        <Option value={item.typeName} key={item.typeName}>{item.typeName}</Option>
                                    )
                                })
                            }

                        </Select> : null
                }
                {
                    this.props.RangePickerShow?null: <Button  icon="delete" style={{marginLeft:'24px'}} onClick={()=>{
                        this.props.allDelete&&this.props.allDelete()
                    }
                    }>清除下载记录</Button>

                }
                {
                    this.props.RangePickerShow?null:<Button  icon="redo" style={{marginLeft:'24px'}} onClick={()=>{
                        this.props.refresh&&this.props.refresh()
                    }}>刷新</Button>
                }
                {
                    this.props.RangePickerShow?null:<div style={{color:'red',marginLeft:'40px'}}>仅保留7天下载记录</div>
                }


            </div>
        )
    }
     handleChange(value) {
        this.state.selectName =value
        this.state.typeList&& this.state.typeList.length&& this.state.typeList.forEach((item,index)=>{
            if(item.typeName === value){
                this.state.selectType =item.suffixList
            }
        });
        this.setState({},()=>{
            this.props.onSaveCallback && this.props.onSaveCallback(this.state.searchText, this.state.selectType, this.state.startTime, this.state.endTime)
        })
    }
    //时间选择器
    rangePickerChange = (moment) => {

        if( moment.length){
            let startTime = moment[0]._d.setHours(0, 0, 0, 0);
            let endTime = moment[1]._d.setHours(23, 59, 59);
            let sTime = new Date(startTime).getTime();
            let eTime = new Date(endTime).getTime();
            this.setState({startTime: sTime, endTime: eTime}, () => {
                this.props.onSaveCallback && this.props.onSaveCallback(this.state.searchText, this.state.selectType, this.state.startTime, this.state.endTime)
            })
        }else{
            this.setState({startTime: '', endTime: ''}, () => {
                this.props.onSaveCallback && this.props.onSaveCallback(this.state.searchText, this.state.selectType, this.state.startTime, this.state.endTime)
            })
        }
    };
    getAllType() {
        this.request({
            url: "/cm-sites-storage-management/resourceType/getAll",
            method: "get",
            body: '',
            callBack: (data) => {
                let all = [{typeName: '全部类型', suffixList: []}]
                let newData = [...all, ...data]
                this.setState({typeList: newData}, () => {

                })
            }
        });
    }
}